module.exports = __webpack_public_path__ + "static/media/scheduler_text_mpm.fb1e7d54.xlsx";